export const actionTypes = {
  FETCH_HARVEST_BY_VARIETY_TABLE_DATA_START:
    "REPORTS/FETCH_HARVEST_BY_VARIETY_TABLE_DATA_START",
  SET_HARVEST_BY_VARIETY_TABLE_DATA:
    "REPORTS/SET_HARVEST_BY_VARIETY_TABLE_DATA",
  FETCH_HARVEST_BY_VARIETY_TABLE_DATA_FAILED:
    "REPORTS/FETCH_HARVEST_BY_VARIETY_TABLE_DATA_FAILED",

  FETCH_HARVEST_BY_VARIETY_TABLE_LIST_START:
    "REPORTS/FETCH_HARVEST_BY_VARIETY_TABLE_LIST_START",
  SET_HARVEST_BY_VARIETY_TABLE_LIST:
    "REPORTS/SET_HARVEST_BY_VARIETY_TABLE_LIST",
  FETCH_HARVEST_BY_VARIETY_TABLE_LIST_FAILED:
    "REPORTS/FETCH_HARVEST_BY_VARIETY_TABLE_LIST_FAILED"
};
